import { Helmet } from "react-helmet-async";
export default function ConfirmedPage() {
  return (
    <main className="entry-container">
      <Helmet>
        <title>Workshop Access Confirmed | Calm But Capable</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <section className="entry-card">
        <p className="entry-eyebrow">Welcome to</p>

        <h1 className="entry-title">The Sanctuary</h1>

        <p className="entry-tagline">
  Your email has been successfully verified.
</p>

        <p className="entry-subtitle">
          Your workshop access email has been sent and should arrive within the next few minutes.
        </p>

        <p className="entry-subtitle">
          Please check your inbox for the workshop link and companion workbook.
        </p>

        <p className="entry-subtitle">
           If you do not see the email within a few minutes, please check your spam or junk folder.
        </p>

        <p className="entry-small-print">
          Thank you for being part of the early Sanctuary journey.
        </p>
      </section>
    </main>
  );
}